import { render, staticRenderFns } from "./ChannelDetails.vue?vue&type=template&id=998726ac&"
import script from "./ChannelDetails.vue?vue&type=script&lang=js&"
export * from "./ChannelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports